import { Badge, Box, Button } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { MouseEvent } from 'react';
import { SearchComponent } from '../Search/SearchComponent';

export interface TableFiltersContainerProps {
  searchValue: string;
  onSearchChange: (search: string) => void;
  activeFilters: number;
  onFiltersClick: (event: MouseEvent<HTMLElement>) => void;
  show?: boolean;
}

export function TableFiltersContainer({
  searchValue,
  onSearchChange,
  activeFilters,
  onFiltersClick,
  show = true,
}: TableFiltersContainerProps) {
  const handleChangeSearch = (value: string) => {
    onSearchChange(value);
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <SearchComponent
        searchValue={searchValue}
        handleChange={handleChangeSearch}
      />
      {show && (
        <Box paddingRight="12px">
          <Badge badgeContent={activeFilters} color="primary">
            <Button
              startIcon={<FilterListIcon />}
              variant="outlined"
              color="primary"
              size="small"
              onClick={onFiltersClick}
            >
              Filters
            </Button>
          </Badge>
        </Box>
      )}
    </Box>
  );
}
